import {
  useFetchObjectDataByFormCodeMutation,
  useFetchObjectDataByFormCodeWithInternalIdMutation,
} from '@redux/api'

import { FIELD_VALUE_TYPE } from '@constants'

// Важно учитывать, что благодаря fixedCacheKey, вызов fetch приведёт к обновлению данных везде, где используется этот хук
export const useFetchObjectDataWithFixedKey = (globalId: string, typeId?: FIELD_VALUE_TYPE) => {
  const fetchObjectData =
    typeId === FIELD_VALUE_TYPE.OBJ_INTERNAL_ID_LINK
      ? useFetchObjectDataByFormCodeWithInternalIdMutation
      : useFetchObjectDataByFormCodeMutation

  return fetchObjectData({
    fixedCacheKey: `display-form-fetch-object-data-${globalId}`,
  })
}
